angular.module('dashboard').controller('AlertsDashboardCtrl',
    ['$scope', '$q', 'TransitionManager', 'MyMessagesService', 'MyChartService', 'DashboardService', 'PatientPortalStorageRepository', 'PatientSettingsRepository',
        function ($scope, $q, TransitionManager, MyMessagesService, MyChartService, DashboardService, PatientPortalStorageRepository, PatientSettingsRepository) {

            'use strict';

            $scope.loading = true;

            $scope.thumbnailSrc = MyChartService.getMaleThumbnailSrc(50,50);
            $scope.labs = null;
            $scope.messages = null;
            $scope.myChart = {'Config': ''};
            $scope.displayLabResults = PatientSettingsRepository.getFeatureList().ViewLabTestResults.IsActive;
            $scope.displayMessages = PatientSettingsRepository.getFeatureList().SendReceiveMessages.IsActive;

            var activePatientId = PatientPortalStorageRepository.getActivePatient().id;

            function getNewLabResults() {
                return MyChartService
                    .getNewLabResults(activePatientId)
                    .then(function (data) {
                        $scope.labs = data;
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    });
            }

            function getMyChartConfig() {
                return MyChartService
                    .getMyChartConfig()
                    .then(function (config) {
                        $scope.myChart.Config = config;
                    });
            }

            function getNewMessages() {
                return MyMessagesService
                    .getNewMessages()
                    .then(function (data) {
                        $scope.messages = data;
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    });
            }


            $scope.load = function(tile) {
                $scope.tile = tile;

                loadPage();
            };

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();
                activePatientId = PatientPortalStorageRepository.getActivePatient().id;

                var messagesPromise = getNewMessages();
                var labsPromise = getNewLabResults();
                var chartConfigPromise = getMyChartConfig();

                $q.all([messagesPromise, labsPromise, chartConfigPromise]).then(function () {
                    $scope.loading = false;
                });
            }

            $scope.updateCollapseState = function updateCollapseState()
            {
                $scope.tile.IsCollapsed = !$scope.tile.IsCollapsed;
                DashboardService.setPatientDashboardTileState($scope.tile);
            };

            $scope.displayAlertMessageThread = function displayAlertMessageThread(message) {
                TransitionManager.transition({appRoute: 'myMessagesDisplayMessageThread', opts: {displayMode: 'received', id: message.MessageId, updateNotification: message.NewMessage}});
            };

            $scope.displayAlertMyChartLabs = function displayAlertMyChartLabs() {
                TransitionManager.transition({appRoute: $scope.myChart.Config.ViewLabResults.Route, opts: {id: activePatientId}});
            };

        }
    ]
);